// extracted by mini-css-extract-plugin
export default {"root":"About_root__IAMtG","form":"About_form__NecBn","blog":"About_blog__cr3fE"};